import tippy from 'tippy.js';
import './ACAD.scss';

import {PageManager} from 'genesis-packages/core';

export default class ACAD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const toolTips = document.getElementsByClassName('js-acad-tooltip');

		for (const tooltip of toolTips) {
			tippy(tooltip, {
				appendTo: 'parent',
				arrow: true,
				interactive: true,
				maxWidth: 350,
				placement: 'top',
				theme: 'basic-tooltip',
				zIndex: 2
			});
		}

		const acadForm = document.getElementById('acad-form');
		if (acadForm) {
			acadForm.addEventListener('submit', (e) => this.acadFormSubmit(e, acadForm));
		}
	}

	async acadFormSubmit (e, form) {
		if (window.grecaptcha) {
			e.preventDefault();
			await window.grecaptcha.execute('6Lds7CAaAAAAAG53S9JauGJy5JSqSY02rq41X2dI', {action: 'submit'}).then(function (token) {
				document.getElementById('g-recaptcha-response').value = token;
				form.submit();
			});
		}
	}

};
